import {
  Unit_instance3vdlo4e4f5ggx as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HttpResponseValidator2d6ie1tmzg8fi as HttpResponseValidator,
  get_ExpectSuccessAttributeKey20jj5fup38v1g as get_ExpectSuccessAttributeKey,
} from './HttpCallValidator.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { savemjbqee915hc5 as save } from '../call/SavedCall.mjs';
import { bodyAsText3u6keg6e36dj9 as bodyAsText } from '../statement/HttpResponse.mjs';
import { MalformedInputExceptionbvc6h5ij0ias as MalformedInputException } from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ValidateMark() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return ValidateMark;
}
var ValidateMark;
function get_LOGGER() {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  return LOGGER;
}
var LOGGER;
function addDefaultResponseValidation(_this__u8e3s4) {
  _init_properties_DefaultResponseValidation_kt__wcn8vr();
  HttpResponseValidator(_this__u8e3s4, ($this$HttpResponseValidator) => {
    $this$HttpResponseValidator.i5n_1 = _this__u8e3s4.j5h_1;
    $this$HttpResponseValidator.j5n(addDefaultResponseValidation$lambda$slambda());
    return Unit_instance;
  });
}
var ResponseExceptionClass;
function ResponseException() {
  if (ResponseExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      constructor(response, cachedResponseText) {
        return new.target.p5n(response, cachedResponseText);
      }
      static p5n(response, cachedResponseText) {
        var $this = this.o('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"');
        captureStack($this, $this.o5n_1);
        $this.n5n_1 = response;
        return $this;
      }
    }
    initMetadataForClass($, 'ResponseException');
    ResponseExceptionClass = $;
  }
  return ResponseExceptionClass;
}
var RedirectResponseExceptionClass;
function RedirectResponseException() {
  if (RedirectResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.x5n(response, cachedResponseText);
      }
      static x5n(response, cachedResponseText) {
        var $this = this.p5n(response, cachedResponseText);
        captureStack($this, $this.w5n_1);
        $this.v5n_1 = 'Unhandled redirect: ' + response.y5i().r5i().z5i().j52_1 + ' ' + response.y5i().r5i().a5j().toString() + '. ' + ('Status: ' + response.h5j().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.v5n_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'RedirectResponseException');
    RedirectResponseExceptionClass = $;
  }
  return RedirectResponseExceptionClass;
}
var ClientRequestExceptionClass;
function ClientRequestException() {
  if (ClientRequestExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.f5o(response, cachedResponseText);
      }
      static f5o(response, cachedResponseText) {
        var $this = this.p5n(response, cachedResponseText);
        captureStack($this, $this.e5o_1);
        $this.d5o_1 = 'Client request(' + response.y5i().r5i().z5i().j52_1 + ' ' + response.y5i().r5i().a5j().toString() + ') ' + ('invalid: ' + response.h5j().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.d5o_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ClientRequestException');
    ClientRequestExceptionClass = $;
  }
  return ClientRequestExceptionClass;
}
var ServerResponseExceptionClass;
function ServerResponseException() {
  if (ServerResponseExceptionClass === VOID) {
    class $ extends ResponseException() {
      constructor(response, cachedResponseText) {
        return new.target.n5o(response, cachedResponseText);
      }
      static n5o(response, cachedResponseText) {
        var $this = this.p5n(response, cachedResponseText);
        captureStack($this, $this.m5o_1);
        $this.l5o_1 = 'Server error(' + response.y5i().r5i().z5i().j52_1 + ' ' + response.y5i().r5i().a5j().toString() + ': ' + (response.h5j().toString() + '. Text: "' + cachedResponseText + '"');
        delete $this.message;
        return $this;
      }
      r() {
        return this.l5o_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'ServerResponseException');
    ServerResponseExceptionClass = $;
  }
  return ServerResponseExceptionClass;
}
function addDefaultResponseValidation$lambda$slambda() {
  return constructCallableReference(function *(response, $completion) {
    var expectSuccess = response.y5i().s5i().k4n(get_ExpectSuccessAttributeKey());
    var tmp;
    if (!expectSuccess) {
      get_LOGGER().c4u('Skipping default response validation for ' + response.y5i().r5i().a5j().toString());
      return Unit_instance;
    }
    var statusCode = response.h5j().w54_1;
    var originCall = response.y5i();
    var tmp_0;
    if (statusCode < 300 || originCall.s5i().m4n(get_ValidateMark())) {
      return Unit_instance;
    }
    // Inline function 'kotlin.apply' call
    var this_0 = yield* save(originCall, $completion);
    this_0.s5i().n4n(get_ValidateMark(), Unit_instance);
    var exceptionCall = this_0;
    var exceptionResponse = exceptionCall.t5g();
    var tmp_1;
    try {
      tmp_1 = yield* bodyAsText(exceptionResponse, VOID, $completion);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof MalformedInputException()) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = '<body failed decoding>';
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var exceptionResponseText = tmp_1;
    var exception = (300 <= statusCode ? statusCode <= 399 : false) ? RedirectResponseException().x5n(exceptionResponse, exceptionResponseText) : (400 <= statusCode ? statusCode <= 499 : false) ? ClientRequestException().f5o(exceptionResponse, exceptionResponseText) : (500 <= statusCode ? statusCode <= 599 : false) ? ServerResponseException().n5o(exceptionResponse, exceptionResponseText) : ResponseException().p5n(exceptionResponse, exceptionResponseText);
    get_LOGGER().c4u('Default response validation for ' + response.y5i().r5i().a5j().toString() + ' failed with ' + exception.toString());
    throw exception;
  }, 1);
}
var properties_initialized_DefaultResponseValidation_kt_akvzqt;
function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
  if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
    properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'ValidateMark';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp = getKClass(Unit());
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_0;
    try {
      tmp_0 = createKType(getKClass(Unit()), arrayOf([]), false);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    var tmp$ret$2 = tmp_0;
    var tmp$ret$1 = new (TypeInfo())(tmp, tmp$ret$2);
    ValidateMark = new (AttributeKey())(name, tmp$ret$1);
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
  }
}
//region block: exports
export {
  addDefaultResponseValidation as addDefaultResponseValidation1d06vtgr9flaj,
};
//endregion

//# sourceMappingURL=DefaultResponseValidation.mjs.map
